import { __assign, __rest } from "tslib";
import React from 'react';
import { RadioboxRadio as RadioboxRadioCommon } from './Radiobox-Radio';
import { cnRadiobox as cn } from '../Radiobox';
import { withControl } from '../../withControl/withControl@desktop';
export * from './Radiobox-Radio';
export var RadioboxRadio = withControl(function (_a) {
    var className = _a.className, hovered = _a.hovered, props = __rest(_a, ["className", "hovered"]);
    return (React.createElement(RadioboxRadioCommon, __assign({}, props, { className: cn('Radio', { hovered: hovered }, [className]) })));
});
